<div class="content-with-filled-button">

    <h2 class="sub-title" id="generalTitle">
        {{ copyService.copies.operation_currency_title }}
    </h2>
    <div class="main">
        <voxel-checkbox-group id="checkBoxGroup">
            <voxel-checkbox class="operation-check-box" *ngFor="let operation of listOperation" id="operationCurrencyId" [label]="operation.label" [checked]="operation.checked" name="operation" [value]="operation.value" (checkboxChange)="checkboxChange($event, operation)">
            </voxel-checkbox>
        </voxel-checkbox-group>
    </div>
</div>
<app-controls id="operationCurrencyBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.operation_currency_next_button_text" [nextDisabled]="stateButton" (next)="next()"></app-controls>